var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoAlertCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_2678_36368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.17538 0 0 7.17538 0 16C0 24.8246 7.17538 32 16 32C24.8246 32 32 24.8246 32 16C32 7.17538 24.8246 0 16 0Z",
    fill: "#F01A1A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 8,
    width: 4,
    height: 11,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 20,
    width: 4,
    height: 4,
    rx: 1,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2678_36368"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAlertCircle);
export default __webpack_public_path__ + "static/media/ico-alert-circle.3933dffa04b28e31ee7739e0665f975a.svg";
export { ForwardRef as ReactComponent };